<template>
    <div class="border-top filter-konsumen">
        <SOFilterTitle :title="title" :id="id" :diterapkan="diterapkan" />
        <div class="content" :id="id" :class="{ hidden: !diterapkan }">
            <div class="m-d-16">
                <SOInputSelect
                    :title="'Pengaturan'"
                    :options="optionPengaturan"
                    :selected="pengaturan"
                    @option-selected="setPengaturan"
                />
            </div>
            <div v-if="pengaturan === 'not-all'">
                <div class="selected">
                    <label class="item-selected m-d-8" v-for="(item, key) in getSelectedItem" :key="`item-${key}`">
                        <span class="m-d-0">{{ item.label }}</span>
                        <span @click="onDeleteItem(item)">
                            <SOIconBase view-box="0 0 28 33" width="28" height="33">
                                <template v-slot:icon>
                                    <CloseX2833 />
                                </template>
                            </SOIconBase>
                        </span>
                    </label>
                </div>
                <div class="m-d-8 m-t-8">
                    <SOInputSearch
                        id="cari-konsumen"
                        placeholder="Ketuk untuk mencari...."
                        value=""
                        autocomplete="off"
                        :do-searching="loadOptinos"
                        :delay-time="500"
                    />
                </div>
                <div class="list-options">
                    <p class="m-d-4 f-12 f-c-midgrey f-regular">Hasil Pencarian</p>
                    <label
                        class="options"
                        v-for="(item, key) in dataOptions"
                        :key="`opt-${key}`"
                        @click="selected(item)"
                    >
                        <span class="m-d-0">{{ item.label }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import CloseX2833 from "@/so-components/global/icons/iconPacks/CloseX2833.vue";

import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";

export default {
    name: "SOFilterKonsumen",
    components: {
        SOFilterTitle,
        SOIconBase,
        CloseX2833,
        SOInputSearch,
        SOInputSelect,
    },
    props: {
        id: String,
        title: {
            type: String,
            default: "Konsumen",
        },
    },
    data() {
        return {
            diterapkan: true,
            dataOptions: [],
            pengaturan: "all",
            optionPengaturan: [
                { id: "all", text: "Semua Konsumen Sekaligus" },
                { id: "not-all", text: "Hanya  Konsumen Tertentu" },
            ],
        };
    },
    mounted() {
        this.diterapkan = this.filterItem.konsumen.length > 0;
		this.pengaturan = this.filterItem.konsumen.length > 0 ? "not-all" : "all";
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        ...mapGetters("metaModule", {
            konsumenList: "getKonsumenTiny",
        }),
        getSelectedItem() {
            return this.filterItem.konsumen;
        },
        isSelected() {
            return function (id) {
                return this.getSelectedItem.find((item) => item.id === id);
            };
        },
    },
    methods: {
        ...mapActions({
            fetchKonsumen: `metaModule/fetchKonsumenTiny`,
        }),
        selected(val) {
            let temp = this.filterItem;

            temp.konsumen.push(val);
            this.$store.commit("filterGlobalModule/setFilterItem", temp);
            this.diterapkan = this.filterItem.konsumen.length > 0;

            this.dataOptions = this.dataOptions.filter((opt) => opt.id !== val.id);
        },
        setPengaturan(val) {
            this.pengaturan = val;
        },
        onDeleteItem(val) {
            let nItem = this.getSelectedItem.filter((item) => item.id !== val.id);
            let temp = this.filterItem;

            temp.konsumen = nItem;
            this.$store.commit("filterGlobalModule/setFilterItem", temp);

            this.diterapkan = this.filterItem.konsumen.length > 0;
        },
        async loadOptinos(val) {
            if (!val) {
                this.dataOptions = [];
                return;
            }
            await this.fetchKonsumen({ searchKey: val });

            this.dataOptions = [];
            this.konsumenList?.forEach((konsumen) => {
                this.dataOptions.push({
                    id: konsumen.idcustomer,
                    label: konsumen.nama,
                });
            });
        },
    },
};
</script>
<style scoped>
.filter-konsumen .content {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 3px;
    margin-left: 20px;
    margin-right: 20px;
    padding: 8px;
}

.filter-konsumen .content .options,
.filter-konsumen .content .item-selected {
    background: #f6f6f6;
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 6px 0px 6px 8px;
    margin-right: 8px;
    width: fit-content;
}

.filter-konsumen .content .options {
    padding-right: 8px;
}

.filter-konsumen .hidden {
    display: none;
}
</style>
